<script lang="ts">
  interface Props {
    message: string;
    compact?: boolean;
  }

  const { message, compact = false }: Props = $props();
</script>

<div class="dashboard-loading" class:compact role="status" aria-live="polite">
  <span class="loading-orbit" aria-hidden="true"></span>
  <p>{message}</p>
</div>

<style>
  .compact {
    min-height: 8rem;
    border: 0;
    background: transparent;
  }
</style>
